<template>
  <div>
    <AppSelect
      :value="value"
      :options="airportOptions"
      label="Flughafen"
      :multiple="isMultipleAllowed"
      :placeholder="placeholder || '---'"
      :loading="isLoading"
      :internal-search="false"
      :dropup="openDirection === 'top'"
      :disabled="disabled"
      :style="cssProps"
      @search-change="onSearchFlughafen"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AppSelect from '@/components/common/app-select/app-select.vue';

export default {
  components: {
    AppSelect,
  },
  data() {
    return {
      searchFilter: null,
    };
  },
  props: {
    isMultipleAllowed: { type: Boolean, default: false },
    value: { type: [String, Array] },
    filterCountry: { type: String, default: null },
    placeholder: { type: String },
    openDirection: { type: String, default: '' },
    isSidebarTerminplanung: { type: Boolean, default: false },
    // Überschreibt die Feldhöhe
    height: { type: String, default: null },
    isChangedMetadata: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    airportBlacklist: { type: Array, default: () => [] },
  },
  methods: {
    onSearchFlughafen($event) {
      this.searchFilter = $event;
    },
  },
  computed: {
    ...mapState({
      flughaefen(state) {
        return state.flughaefen.flughaefen.filter(
          flgh => flgh.iataCode !== 'PNH' && !this.airportBlacklist.includes(flgh.iataCode)
        );
      },
      isLoading: state => state.flughaefen.isLoading,
    }),
    airportsList() {
      if (this.searchFilter) {
        return this.flughaefen.filter(airport =>
          airport.iataCode.toLowerCase().startsWith(this.searchFilter.toLowerCase())
        );
      } else if (this.filterCountry) {
        const filteredAirports = this.flughaefen.filter(airport => airport.country === this.filterCountry);
        return filteredAirports.length > 0 ? filteredAirports : this.flughaefen;
      } else {
        const countryFilter = this.$route.path.replace('/reisen/', '').substring(0, 2);
        const filteredByCountry = this.flughaefen.filter(airport => airport.country === countryFilter);
        return filteredByCountry.length > 0 ? filteredByCountry : this.flughaefen;
      }
    },
    // Die gefilterte Liste wird auf das Optionsformat des Selects gebracht
    // Der bereits gewählte Wert wird ergänzt, damit er bei aktivem Suchbegriff sichtbar bleibt
    airportOptions() {
      const codes = new Set(this.airportsList.map(airport => airport.iataCode));
      const gewaehlt = Array.isArray(this.value) ? this.value : this.value ? [this.value] : [];
      gewaehlt.filter(Boolean).forEach(code => codes.add(code));
      return [...codes].map(iataCode => ({ value: iataCode, text: iataCode }));
    },
    cssProps() {
      return {
        '--app-select-border-color': this.isSidebarTerminplanung ? 'transparent' : '#e8e8e8',
        '--app-select-height': this.height || (this.isSidebarTerminplanung ? '40px' : '38px'),
        '--app-select-padding-x': this.isSidebarTerminplanung ? '4px' : '8px',
        '--app-select-background': this.isChangedMetadata
          ? '#3699FF50'
          : this.disabled
          ? '#F3F6F9'
          : '#ffffff',
      };
    },
  },
};
</script>
